import { FC, useState } from 'react'
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Typography,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Sermon } from '../../client/types/sermon'
import { SermonSeries } from '../../client/types/sermon-series'
import { callDeleteSermon } from '../../client/api'

type DeleteDialogProps = {
  open: boolean
  handleClose: () => void
  sermon?: Sermon
  sermonSeries?: SermonSeries
}

const DeleteDialog: FC<DeleteDialogProps> = ({
  open,
  handleClose,
  sermon,
  sermonSeries,
}) => {
  const navigate = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const [showDeleteError, setShowDeleteError] = useState<boolean>(false)
  const [deleteError, setDeleteError] = useState<string>('')

  const getTitle = () => {
    let title = 'NOT DEFINED'
    if (sermon) title = sermon.title
    else if (sermonSeries) title = sermonSeries.title

    return title
  }

  const handleYesDelete = async () => {
    setIsSubmitting(true)
    try {
      if (sermon) {
        await callDeleteSermon(sermon.id)
      }
      navigate(0)
    } catch (err: any) {
      setDeleteError(err.message)
      setShowDeleteError(true)
    } finally {
      handleClose()
      setIsSubmitting(false)
    }
  }

  const handleCloseDeleteError = () => {
    setDeleteError('')
    setShowDeleteError(false)
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Delete {sermon && 'sermon'}
          {sermonSeries && 'sermon series'}?
        </DialogTitle>
        <DialogContent>
          <Typography id="alert-dialog-description">
            Are you sure you want to delete {sermon && 'sermon'}
            {sermonSeries && 'sermon series'} &quot;{getTitle()}&quot;
          </Typography>
        </DialogContent>
        <DialogActions>
          {!isSubmitting ? (
            <>
              <Button onClick={handleYesDelete}>Yes</Button>
              <Button onClick={handleClose} color="error" autoFocus>
                No
              </Button>
            </>
          ) : (
            <CircularProgress />
          )}
        </DialogActions>
      </Dialog>
      <Snackbar
        open={showDeleteError}
        onClose={handleCloseDeleteError}
        autoHideDuration={3000}
      >
        <Alert severity="error">{deleteError}</Alert>
      </Snackbar>
    </>
  )
}

export default DeleteDialog
